"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const gridHeight = {
    height: 'calc(100vh - 270px)',
};
const gridHeightHistory = {
    height: '60vh',
};
const modalContainer = (theme) => ({
    width: 'calc(37vw + 200px)',
    padding: '24px',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalContainerMutation = (theme) => ({
    width: 'fit-content',
    minWidth: 800,
    padding: 24,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalContainerDetails = (theme) => ({
    width: 'fit-content',
    minWidth: 800,
    padding: '20px',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalConfirmContainer = {
    padding: 10,
    paddingTop: 0,
    width: 432,
    height: 376,
};
const modalHeader = {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    alignItems: 'center',
    padding: 0,
    marginBottom: 26
};
const itemAdd = {
    columnGap: 12,
    display: 'grid',
    marginBottom: 24,
    alignItems: 'center',
    gridTemplateColumns: '130px 225px',
};
const inputItem = {
    height: 27,
    borderRadius: 5,
};
const buttonSave = (color) => ({
    height: 40,
    display: 'flex',
    borderRadius: 8,
    padding: '12px 20px',
    alignItems: 'center',
    backgroundColor: color,
});
const buttonTitle = {
    margin: 0,
    fontSize: 16,
    marginLeft: 8,
    fontWeight: '500',
    lineHeight: '24px'
};
const buttonDelete = {
    padding: '0 5px',
    display: 'flex',
    fontSize: 'large',
    fontWeight: 'normal',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: constants_1.color.white,
    backgroundColor: constants_1.color.redDark,
    height: 35,
    width: 65,
    borderRadius: 10,
};
const modalTitle = {
    margin: 0,
    fontSize: 20,
};
const dropdownStyle = (theme) => ({
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.borderGrey,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const siloSubComponentContainer = {
    display: 'flex',
    gridTemplateColumns: '69% auto',
    gridGap: '10px',
    // minHeight: '77vh',
    marginTop: 20,
};
const button = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '130px',
    borderRadius: 8,
    padding: '12px',
    backgroundColor: constants_1.color.buttonDark,
});
const buttonPassive = (color) => ({
    display: 'flex',
    alignItems: 'center',
    justifySelf: 'right',
    justifyContent: 'center',
    borderRadius: 8,
    padding: '12px',
    backgroundColor: color
});
const buttonModify = (color) => ({
    display: 'flex',
    alignItems: 'center',
    justifySelf: 'right',
    justifyContent: 'center',
    borderRadius: 8,
    padding: '12px',
    backgroundColor: color,
});
const buttonFont = {
    fontSize: '20px',
    fontWeight: '600',
    margin: 0,
    marginLeft: 8,
};
const buttonFontPassive = {
    fontSize: '12px',
    fontWeight: '600',
    margin: 0,
    marginLeft: 8,
};
const siloSubComponentContainerRightBody = theme => ({
    backgroundColor: theme === 'light' ? '#F5F6F7' : constants_1.color.backgroundDark,
    margin: '10px 0px 10px 0px',
    padding: '15px 20px',
    borderRadius: '10px',
});
const siloSubComponentContainerRightText = {
    display: 'grid',
    gridTemplateColumns: '40% auto',
    marginBottom: '3vh',
    marginLeft: '5px',
    fontSize: '1.5vh'
};
const siloSubComponentContainerRight = theme => ({
    width: '100%',
    height: '71.5vh',
    // minWidth: 500,
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
    borderRadius: '10px',
    padding: '10px',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
});
const siloSubComponentContainerRightHidder = {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    fontWeight: 'bold',
};
const siloSubComponentContainerRightHidderStatus = {
    display: 'flex',
    alignItems: 'center',
    direction: 'rtl',
};
const siloSubComponentContainerRightHidderButton = {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'space-between'
};
const siloSubComponentContainerLeft = theme => ({
    width: '100%',
    height: '15vh',
    // minWidth: 1080,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
    display: 'grid',
    gridTemplateRows: '67% auto',
    padding: '10px',
    gridGap: '30px',
    borderRadius: '10px',
    marginTop: 10,
});
const siloSubComponentContainerMiddle = theme => ({
    width: '23vw',
    height: '71.6vh',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
    display: 'grid',
    gridTemplateRows: '5% auto',
    padding: '10px',
    gridGap: '30px',
    borderRadius: '10px',
});
const siloSubComponentContainerLeftBottom = theme => ({
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
    borderRadius: '10px',
    padding: '5px',
    display: 'grid',
    gridGap: '10px',
    gridTemplateRows: '15% auto',
});
const siloSubComponentContainerLeftBottomLed = { display: 'flex', alignItems: 'center' };
const siloSubComponentContainerLeftBottomLedHidder = {
    marginRight: '5px',
    fontSize: '20px',
    fontWeight: '600',
};
const siloSubComponentContainerLeftBottomLedText = {
    display: 'flex',
    flexDirection: 'column',
    height: '10vh',
    alignContent: 'center',
    justifyContent: 'center',
    backgroundColor: 'black',
    fontSize: 'xx-large',
    marginBottom: '10px',
    borderRadius: '10px',
};
const btnModifyPassive = {
    display: 'grid',
    columnGap: 12,
    alignItems: 'center',
    gridTemplateColumns: 'auto auto auto',
};
exports.default = {
    button,
    itemAdd,
    inputItem,
    buttonFont,
    gridHeight,
    modalTitle,
    buttonSave,
    modalHeader,
    buttonTitle,
    buttonDelete,
    dropdownStyle,
    buttonPassive,
    modalContainer,
    buttonFontPassive,
    gridHeightHistory,
    modalContainerDetails,
    modalConfirmContainer,
    modalContainerMutation,
    siloSubComponentContainer,
    siloSubComponentContainerLeft,
    siloSubComponentContainerRight,
    siloSubComponentContainerMiddle,
    siloSubComponentContainerRightBody,
    siloSubComponentContainerRightText,
    siloSubComponentContainerLeftBottom,
    siloSubComponentContainerRightHidder,
    siloSubComponentContainerLeftBottomLed,
    siloSubComponentContainerLeftBottomLedText,
    siloSubComponentContainerRightHidderStatus,
    siloSubComponentContainerRightHidderButton,
    siloSubComponentContainerLeftBottomLedHidder,
    btnModifyPassive,
    buttonModify,
};
